import { render, staticRenderFns } from "./toastModal.vue?vue&type=template&id=23f23e5d&scoped=true&"
import script from "./toastModal.vue?vue&type=script&lang=js&"
export * from "./toastModal.vue?vue&type=script&lang=js&"
import style0 from "./toastModal.vue?vue&type=style&index=0&id=23f23e5d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f23e5d",
  null
  
)

export default component.exports